var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Stack } from "@mui/material";
import detranLogotipo from "../assets/detran-logo.svg";
import mtLoginLogotipo from "../assets/mt-login-logo.svg";
import { Colors } from "../util/theme";
export var Login = function () {
    var navigate = useNavigate();
    var _a = useState(false), showLoginButton = _a[0], setShowLoginButton = _a[1];
    useEffect(function () {
        setTimeout(function () {
            setShowLoginButton(true);
        }, 1000);
    }, []);
    return (_jsxs("div", __assign({ style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            width: "100vw",
            height: "100vh",
        } }, { children: [_jsx("div", __assign({ style: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                } }, { children: _jsx("img", { src: detranLogotipo, alt: "logotipo do detran", style: { width: "8.125rem" } }) })), showLoginButton && (_jsx(Stack, __assign({ sx: {
                    backgroundColor: Colors.AZUL_GOV,
                }, height: "7rem", padding: "2rem 1rem 3rem" }, { children: _jsxs(Button, __assign({ onClick: function () { return navigate("/home"); }, variant: "contained", sx: {
                        backgroundColor: "white",
                        color: "black",
                        paddingY: "0.5rem",
                    } }, { children: [_jsx("span", { children: "ENTRAR COM" }), _jsx("img", { src: mtLoginLogotipo, alt: "MT login", style: { marginLeft: "1.5rem" } })] })) })))] })));
};
